import { clubesParaEscolher, PAISES_MUNDO, paisDaLiga } from '../core';
import { LIBERTADORES_LIBERADA } from './recursos';
import { app } from './app';
import { botoesConta } from './conta';
import { escudo, icone } from './icones';
import { esc } from './util';

export function telaInicio(temSave: boolean): string {
  return `<div class="bf-inicio">
    <div class="inicio-conta">${botoesConta()}</div>
    <div class="bola-grande" aria-hidden="true"></div>
    <h1 class="logo"><span>WebFoot</span></h1>
    <div class="inicio-botoes">
      <button class="grande-bt" data-a="novo-jogo">${icone('bola', 64)}<span>NOVO JOGO</span></button>
      <button class="grande-bt" data-a="jogo-salvo" ${temSave ? '' : 'disabled'}>${icone('salvar', 64)}<span>JOGO SALVO</span></button>
      <button class="grande-bt" data-a="online-menu">${icone('times', 64)}<span>ONLINE</span></button>
      <button class="grande-bt" data-a="importar-inicio">${icone('editor', 64)}<span>IMPORTAR</span></button>
    </div>
    <input type="file" id="arquivo" accept="application/json,.json" hidden />
    ${app.mensagem ? `<div class="aviso-bf inicio-aviso" role="status">${esc(app.mensagem)}</div>` : ''}
  </div>`;
}

const NACIONALIDADES = ['Brasil', 'Argentina', 'Uruguai', 'Portugal', 'Espanha', 'Itália', 'Alemanha', 'Outra'];

/** Clubes que o técnico pode escolher na tela de novo jogo: os da liga estrangeira escolhida ou os da divisão brasileira escolhida. */
export function clubesDaEscolha(p: Parameters<typeof clubesParaEscolher>[0]): ReturnType<typeof clubesParaEscolher> {
  if (app.novo.ligaMundo) return p.clubes.filter((c) => c.liga === app.novo.ligaMundo);
  return clubesParaEscolher(p, app.novo.divisao === 'b' ? 2 : 1);
}

export function telaNovo(): string {
  const p = app.previa;
  if (!p) return '';
  const clubes = clubesDaEscolha(p).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
  const sel = clubes.find((c) => c.id === app.novo.clubeId) ?? (clubes[0] as (typeof clubes)[number]);
  const opcoes = clubes.map((c) => `<option value="${c.id}" ${c.id === sel.id ? 'selected' : ''}>${esc(c.nome)}</option>`).join('');
  const nac = NACIONALIDADES.map((n) => `<option>${n}</option>`).join('');
  const estrangeira = Boolean(app.novo.ligaMundo);
  const pais = estrangeira ? paisDaLiga(app.novo.ligaMundo as string) : undefined;
  return `<div class="bf-novo">
    <div class="novo-painel">
      <h1 class="marca">WebFoot</h1>
      <h2>Adicionar técnico humano</h2>
      <div class="novo-form">
        <label>Treinar time do país: <select data-ch="novo-pais"><option value="" ${estrangeira ? '' : 'selected'}>Brasil</option>${PAISES_MUNDO.map((p) => `<option value="${esc(p.nome)}" ${pais?.nome === p.nome ? 'selected' : ''}>${esc(p.nome)}</option>`).join('')}</select></label>
        ${
          estrangeira && pais
            ? `<label>Campeonato: <select data-ch="novo-liga">${pais.ligas.map((l) => `<option value="${l.id}" ${l.id === app.novo.ligaMundo ? 'selected' : ''}>${esc(l.nome)}</option>`).join('')}</select></label>`
            : `<label>Campeonato: <select data-ch="novo-div"><option value="a" ${app.novo.divisao === 'b' ? '' : 'selected'}>Brasileirão Série A</option><option value="b" ${app.novo.divisao === 'b' ? 'selected' : ''}>Brasileirão Série B</option></select></label>`
        }
        <label class="check"><input type="checkbox" data-ch="novo-mundo" ${app.novo.semMundo ? '' : 'checked'} /> Incluir as 13 ligas estrangeiras no mesmo save (clubes de verdade, com acesso e rebaixamento nas que têm 2ª divisão; mais pesado)</label>
        ${estrangeira && app.novo.semMundo ? '<p class="cinza peq">Só esta liga, em pontos corridos, sem copas e sem rebaixamento.</p>' : `<label class="check"><input type="checkbox" data-ch="novo-copa" ${app.novo.copa === false ? '' : 'checked'} /> Disputar também a Copa do Brasil no mesmo save</label>${LIBERTADORES_LIBERADA ? `<label class="check"><input type="checkbox" data-ch="novo-lib" ${app.novo.copa === false ? 'disabled' : app.novo.libertadores === false ? '' : 'checked'} /> Disputar também a Libertadores e a Sul-Americana (16 clubes cada: 8 do Brasil e 8 da Argentina)</label>` : ''}`}
        <hr />
        <label>${estrangeira ? 'Clube' : app.novo.divisao === 'b' ? '2ª divisão' : '1ª divisão'}: <select data-ch="novo-clube" ${app.novo.aleatorio ? 'disabled' : ''}>${opcoes}</select></label>
        <label class="check"><input type="checkbox" data-ch="novo-aleatorio" ${app.novo.aleatorio ? 'checked' : ''} /> Escolher um time aleatório</label>
        <hr />
        <label>Nome: <input type="text" id="novo-nome" maxlength="24" value="${esc(app.novo.nome)}" autocomplete="off" /></label>
        <label>Nacionalidade: <select>${nac}</select></label>
        <p class="selecionado">Time selecionado: ${escudo(sel)}<b>${esc(sel.nome)}</b> <span class="cinza">(nível ${sel.nivel}, reputação ${sel.reputacao}, ${sel.capacidade.toLocaleString('pt-BR')} lugares)</span></p>
        <hr />
        <div class="dlg-botoes"><button class="btn" data-a="outro-mundo">Gerar outro campeonato</button>
          <button class="btn" data-a="voltar-inicio">« Voltar ao início</button>
          <button class="btn principal" data-a="iniciar-jogo">Iniciar Jogo »</button></div>
      </div>
    </div></div>`;
}
